module.exports = __webpack_public_path__ + "img/icon-repost.8d8ea222.svg";